import { Color, Radius, Spacing } from 'zens-storybook'
import { StyleSheet, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { Suspense, useState } from 'react'
import { useStore, Draft, ProductData, ApiError, useProductMutation } from 'zens-store'
import { useRouter, useNumberParams } from 'zens-router'
import { useBreadcrumb } from '@dms/hook'
import { LayoutHeader, ProductForm } from '@dms/component'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    margin: Spacing.L,
    padding: Spacing.L,
    backgroundColor: Color.simplyWhite,
    borderRadius: Radius.M,
  },
})

const ProductAdd = () => {
  const router = useRouter()
  const store = useStore()
  const { message } = store
  const [errors, setErrors] = useState<Record<string, string>>()
  const [{ companyId }] = useNumberParams()
  const { t } = useTranslation()
  const mutationProduct = useProductMutation({ companyId })

  const breadcrumb = useBreadcrumb([
    {
      title: t('Devices'),
      href: `/companies/${companyId}/products`,
    },
    {
      title: t('Add device'),
    },
  ])

  const add = async (draft: Draft<ProductData>) => {
    try {
      setErrors({})
      const product = await mutationProduct.create(draft)
      if (!product) throw new Error('Product not created')
      message.add({
        message: t('Device was created successfully'),
        status: 'success',
      })
      draft.settle()
      router.push(`/companies/${companyId}/products`)
    } catch (error) {
      const { message: errorMessage, fields } = error as ApiError
      console.debug(`PRODUCT: Product add failed: ${errorMessage}`)
      if (fields) {
        setErrors(fields)
      } else {
        message.add({
          message: `${t('Device could not be created')}. ${errorMessage}`,
          status: 'error',
        })
      }
    }
  }

  return (
    <View style={styles.container}>
      <LayoutHeader breadcrumb={breadcrumb} title={t('Add device')} />
      <View style={styles.content}>
        <Suspense fallback={<ProductForm.Skeleton />}>
          <ProductForm
            companyId={companyId}
            onSave={add}
            cancelHref={`/companies/${companyId}/products`}
            errors={errors}
          />
        </Suspense>
      </View>
    </View>
  )
}

export default ProductAdd
